export function recipeUnitCost(totalCost: number, netWeight: number, isAuxiliaryRecipe = false) {
  return !isAuxiliaryRecipe && netWeight > 0 ? totalCost / netWeight : totalCost;
}
